import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from "react";
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { useMemo } from 'react';

function BrowsingHistory() {
   // Row Data: The data to be displayed.
   const [rowData, setRowData] = useState([
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Change Password",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Change Password",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Change Password",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
    { UserName: "June Cha", ActionPerformed: "Edit Profile",  IPAddress: "182.65.231.162", Timestamp: "03-Jan-2024 05:28:14",  },
]);

// Column Definitions: Defines the columns to be displayed.
const [colDefs, setColDefs] = useState([
     
    
    { field: "UserName" },
    { field: "ActionPerformed" },
   
    { field: "IPAddress" },
    { field: "Timestamp" },
   
]);
// ...
const defaultColDef = useMemo(() => {
    return {
        flex: 1,
        filter: true,
    }

});
   
    

    return (
        <Container fluid>         
           
          
            <Row className='m-1'>
                <Col sm={4} className='d-flex'>
                    <h6 className='fw-bold'>BrowsingHistory </h6>
                </Col>
                <Col sm={4} className='pb-2'>
                    
                </Col>
                <Col sm={4} >
                    <div class="dropdown float-end">
                      
                    </div>
                </Col>

                <div className="ag-theme-quartz" // applying the grid theme
                     style={{ height: 550 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 20]}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}
                    />
                </div>
                
               
            </Row>
           
        </Container>

    );
}

export default BrowsingHistory